export const removeFromList = _ref => {
  let {
    list,
    key
  } = _ref;
  const i = list.indexOf(key);
  if (i < 0) return list;
  const newList = [...list];
  newList.splice(i, 1);
  return newList;
};
export const addToList = _ref2 => {
  let {
    list,
    key
  } = _ref2;
  return !list.includes(key) ? [...list, key] : list;
};
export const removeFromMap = _ref3 => {
  let {
    map,
    key
  } = _ref3;
  const newMap = {
    ...map
  };
  delete newMap[key];
  return newMap;
};